/**
 * Copyright (c) 2026-present, NDLA.
 *
 * This source code is licensed under the GPLv3 license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

// N.B! AUTOGENERATED FILE. DO NOT EDIT
// Source: RemixIcon
// License: Remix Icon License v1.0
import type { JSX } from "react";
import { Icon, type Props } from "../Icon";
export const PenNibLine = (props: Props): JSX.Element => (
  <Icon fill="currentColor" viewBox="0 0 24 24" {...props}>
    <path d="m16.6 1.04 6.34 6.34a.5.5 0 0 1-.27.85l-1.48.23-5.65-5.66.2-1.48a.5.5 0 0 1 .86-.28m-12 19.1c3.72-3.32 7.99-4.32 12.64-5.51l.44-4.02-4.3-4.3-4.01.45c-1.2 4.65-2.19 8.92-5.52 12.64L2.45 18c2.83-3.3 3.9-6.95 5.3-13.07l6.37-.71 5.66 5.66-.7 6.36c-6.14 1.41-9.8 2.47-13.09 5.3zm5.28-6.02a2 2 0 1 1 2.83-2.83 2 2 0 0 1-2.83 2.83" />
  </Icon>
);
